import { useTheme as useThemeFromProvider } from '@/theme/ThemeProvider';

export const useTheme = useThemeFromProvider;



